export const todayMeals = [
  {
    key: "breakfast",
    name: "早餐",
    icon: "ri-sun-line",
    calories: 420,
    target: 500,
    items: ["燕麦牛奶", "水煮蛋", "蓝莓"],
    time: "08:12",
  },
  {
    key: "lunch",
    name: "午餐",
    icon: "ri-restaurant-line",
    calories: 680,
    target: 800,
    items: ["米饭", "西红柿炒蛋", "清炒时蔬"],
    time: "12:30",
  },
  {
    key: "dinner",
    name: "晚餐",
    icon: "ri-moon-clear-line",
    calories: 0,
    target: 700,
    items: [],
    time: "--",
  },
];

export const todaySummary = {
  intake: 1100,
  target: 2000,
  protein: 52,
  carbs: 140,
  fat: 38,
};